import {
  ImportField,
  ImportModule,
  ImportPreviewRequest,
  ImportPreviewResponse,
  ImportExecuteRequest,
  ImportExecuteResponse,
  ColumnMapping,
} from "@billingnow/zod-schema";
import { apiClient } from "./client";

// ============================================================================
// Types
// ============================================================================

export interface GetImportFieldsResponse {
  fields: ImportField[];
  sampleCsv: string;
}

// ============================================================================
// API Functions
// ============================================================================

/**
 * Get field definitions for a module
 */
export const getImportFields = async (
  module: ImportModule
): Promise<GetImportFieldsResponse> => {
  const response = await apiClient.get<GetImportFieldsResponse>(
    `/api/import/fields/${module}`
  );
  return response.data;
};

/**
 * Preview import (dry run validation)
 */
export const previewImport = async (
  request: ImportPreviewRequest
): Promise<ImportPreviewResponse> => {
  const response = await apiClient.post<ImportPreviewResponse>(
    "/api/import/preview",
    request,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return response.data;
};

/**
 * Execute import
 */
export const executeImport = async (
  request: ImportExecuteRequest
): Promise<ImportExecuteResponse> => {
  const response = await apiClient.post<ImportExecuteResponse>(
    "/api/import/execute",
    request,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return response.data;
};

// ============================================================================
// Re-export types for convenience
// ============================================================================

export type {
  ImportField,
  ImportModule,
  ImportPreviewRequest,
  ImportPreviewResponse,
  ImportExecuteRequest,
  ImportExecuteResponse,
  ColumnMapping,
};
